import { Injectable } from '@angular/core';
import { ICashRegisterVendorInterface } from '../../cash-register-vendor.interface';
import { CashRegisterCloseShiftLocalResponse } from '../../../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-response';
import { CashRegisterControlTapeLocalResponse } from '../../../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-response';
import { CashRegisterLoginLocalResponse } from '../../../../../models/rest/cash-register/login/cash-register-login-local-response';
import { CashRegisterOpenShiftLocalResponse } from '../../../../../models/rest/cash-register/open_shift/cash-register-open-shift-local-response';
import { CashRegisterXReportLocalResponse } from '../../../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-response';
import { CashRegisterZReportBulkLocalResponse } from '../../../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-response';
import { CashRegisterEntity } from '../../../../../models/entity/cash-register/cash-register-entity';
import { CashRegisterCreateBasketResponse } from '../../../../../models/rest/cash-register/sale/cash-register-create-basket-response';
import { CashRegisterPaymentCancelLocalResponse } from '../../../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-response';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CashRegisterPairLocalResponse } from '../../../../../models/rest/cash-register/pair/cash-register-pair-local-response';
import { StringUtils } from '../../../../../utils/string.utils';

@Injectable({
  providedIn: 'root'
})
export class PavoService implements ICashRegisterVendorInterface {
  private baseUrl: string = '';
  appName = "PAVO";
  timeout: 30;
  constructor(
    protected httpClient: HttpClient,) { }
  async pair(cashRegister: CashRegisterEntity, data: CashRegisterPairLocalResponse) {
    this.setBaseUrl(cashRegister);

    return await firstValueFrom(this.httpClient.post(this.baseUrl + "/Pairing", JSON.parse(data.data ?? "")));
  }

  setBaseUrl(data: CashRegisterEntity) {
    if (StringUtils.isEmpty(data.apiUrl)) {
      throw new Error("Yazar kasa ip adresi boş olamaz");
    }
    this.baseUrl = data.apiUrl!;
    if (!this.baseUrl.includes(":4568") && !this.baseUrl.includes(":4567"))
      this.baseUrl = this.baseUrl + ":4568";

    if (!this.baseUrl.startsWith("http://")) {
      this.baseUrl = "http://" + this.baseUrl;
    }


  }
  isLoggedIn(data: CashRegisterEntity) {
    return true
  }

  getToken(cashRegister: CashRegisterEntity) {
    return;
  }
  setToken(cashRegister: CashRegisterEntity, token?: string) {
    return;
  }
  getDeviceInfo(cashRegister: CashRegisterEntity) {
    return;
  }
  login(cashRegister: CashRegisterEntity, data: CashRegisterLoginLocalResponse) {
    return;
  }
  async createSale(cashRegister: CashRegisterEntity, data: CashRegisterCreateBasketResponse) {
    this.setBaseUrl(cashRegister);

    return await firstValueFrom(this.httpClient.post(this.baseUrl + "/CompleteSale", JSON.parse(data.data!)));
  }
  async cancelSale(cashRegister: CashRegisterEntity, data: CashRegisterPaymentCancelLocalResponse) {
    this.setBaseUrl(cashRegister);
    return await firstValueFrom(this.httpClient.post(this.baseUrl + "/CancelSale", JSON.parse(data.data!)));
  }
  openShift(cashRegister: CashRegisterEntity, data: CashRegisterOpenShiftLocalResponse) {
    throw new Error('Method not implemented.');
  }
  closeShift(cashRegister: CashRegisterEntity, data: CashRegisterCloseShiftLocalResponse) {
    throw new Error('Method not implemented.');
  }
  async getXReport(cashRegister: CashRegisterEntity, data: CashRegisterXReportLocalResponse) {
    this.setBaseUrl(cashRegister);
    return await firstValueFrom(this.httpClient.post(this.baseUrl + "/QueryReport", JSON.parse(data.data)));
  }
  async getZReport(cashRegister: CashRegisterEntity, data: CashRegisterZReportBulkLocalResponse) {
    this.setBaseUrl(cashRegister);
    return await firstValueFrom(this.httpClient.post(this.baseUrl + "/QueryReport", JSON.parse(data.data)));
  }
  controlTape(cashRegister: CashRegisterEntity, data: CashRegisterControlTapeLocalResponse) {
    throw new Error('Method not implemented.');
  }
}
